// extracted by mini-css-extract-plugin
export default {"productDescription":"L--z","featuredDescription":"M--z","description":"N--z","more":"O--z","descriptionSku":"P--z"};